import React, { Component } from 'react';
import { ValidationModal } from '../components';
import $ from 'jquery';
import '../css/validations.css'

const EMAIL_FORMAT = /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
const CARDCODE_FORMAT = /^[a-zA-Z0-9\_\-]{4,16}$/;
const FIRSTNAME_FORMAT = /^[a-zA-ZÀ-ÿ\s]{3,15}$/;
const LASTNAME_FORMAT = /^[a-zA-ZÀ-ÿ\s]{3,35}$/;
const PHONE_FORMAT = /^\d{10,10}$/;
const RFC_FORMAT = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;
class NewClientModal extends Component {


    ChangeCardName = async (value) => {
        const { businessPartner, RefreshBusinessPartner } = this.props;
        businessPartner.CardName = value;
        await RefreshBusinessPartner(businessPartner);
    }

    ChangeCardLastName = async (value) => {
        const { businessPartner, RefreshBusinessPartner } = this.props;
        businessPartner.CardLastName = value;
        await RefreshBusinessPartner(businessPartner);
    }

    ChangeCardCode = async (value) => {
        const { businessPartner, RefreshBusinessPartner } = this.props;
        businessPartner.CardCode = value.toUpperCase();
        await RefreshBusinessPartner(businessPartner);
    }

    ChangeLicTradNum = async (value) => {
        const { businessPartner, RefreshBusinessPartner } = this.props;
        businessPartner.LicTradNum = value.toUpperCase();
        await RefreshBusinessPartner(businessPartner);
    }

    ChangePhone = async (value) => {
        const { businessPartner, RefreshBusinessPartner } = this.props;
        businessPartner.Phone = value;
        await RefreshBusinessPartner(businessPartner);
    }

    ChangeGroupNum = async (value) => {
        const { businessPartner, RefreshBusinessPartner } = this.props;
        businessPartner.GroupNum = value;
        await RefreshBusinessPartner(businessPartner);
    }

    ChangePriceListNum = async (value) => {
        const { businessPartner, RefreshBusinessPartner } = this.props;
        businessPartner.PriceListNum = value;
        await RefreshBusinessPartner(businessPartner);
    }

    ChangeGroupCode = async (value) => {
        const { businessPartner, RefreshBusinessPartner } = this.props;
        businessPartner.GroupCode = value;
        await RefreshBusinessPartner(businessPartner);
    }

    ChangeE_mail = async (value) => {
        const { businessPartner, RefreshBusinessPartner } = this.props;
        businessPartner.E_mail = value;
        await RefreshBusinessPartner(businessPartner);
    }

    ValidateFirstName = async () => {
        const { businessPartner} = this.props;
        let element= document.getElementById('firstName');
        let icon=  document.querySelector(`#grupo__firstName i`);
        let text= document.querySelector(`#grupo__firstName .form__input-error`);
        let require= document.querySelector(`#grupo__firstName .form__input-void`);
        if (!businessPartner.CardName == ''){   
            if (!FIRSTNAME_FORMAT.test(businessPartner.CardName)){
                element.classList.add('form__group-incorrect');
                element.classList.remove("form__group-correct");
                icon.classList.add('fa-times-circle');
                icon.classList.add('form__group-incorrect');
                icon.classList.remove('fa-check-circle');
                text.classList.add('form__input-error-active');
                require.classList.remove('form__input-void-active');
            }else{
                element.classList.remove('form__group-incorrect');
                element.classList.add("form__group-correct");
                icon.classList.add('fa-check-circle');
                icon.classList.add('form__group-correct');
                icon.classList.remove('fa-times-circle');
                icon.classList.remove('form__group-incorrect');
                text.classList.remove('form__input-error-active');
                require.classList.remove('form__input-void-active');
            }
        }else{
            element.classList.add('form__group-incorrect');
            element.classList.remove("form__group-correct");
            icon.classList.remove('fa-check-circle');           
            require.classList.add('form__input-void-active');
            text.classList.remove('form__input-error-active');
        }
    }

    ValidateLastName = async () => {
        const { businessPartner} = this.props;
        let element= document.getElementById('lastName');
        let icon=  document.querySelector(`#grupo__lastName i`);
        let text= document.querySelector(`#grupo__lastName .form__input-error`);
        let require= document.querySelector(`#grupo__lastName .form__input-void`);
        if (!businessPartner.CardLastName == ''){ 
            if (!LASTNAME_FORMAT.test(businessPartner.CardLastName)){
                element.classList.add('form__group-incorrect');
                element.classList.remove("form__group-correct");
                icon.classList.add('fa-times-circle');
                icon.classList.add('form__group-incorrect');
                icon.classList.remove('fa-check-circle');
                text.classList.add('form__input-error-active');
                require.classList.remove('form__input-void-active');
            }else{
                element.classList.remove('form__group-incorrect');
                element.classList.add("form__group-correct");
                icon.classList.add('fa-check-circle');
                icon.classList.add('form__group-correct');
                icon.classList.remove('fa-times-circle');
                icon.classList.remove('form__group-incorrect');
                text.classList.remove('form__input-error-active');
                require.classList.remove('form__input-void-active');
            }
        }else{
            element.classList.add('form__group-incorrect');
            element.classList.remove("form__group-correct");
            icon.classList.remove('fa-check-circle');           
            require.classList.add('form__input-void-active');
            text.classList.remove('form__input-error-active');
        }
    }
    
    ValidateCardCode = async () => {
        const { businessPartner} = this.props;
        let element= document.getElementById('cardCode');
        let icon=  document.querySelector(`#grupo__cardCode i`);
        let text= document.querySelector(`#grupo__cardCode .form__input-error`);
        let require= document.querySelector(`#grupo__cardCode .form__input-void`);
        if (!businessPartner.CardCode == ''){
            if (!CARDCODE_FORMAT.test(businessPartner.CardCode)){
                element.classList.add('form__group-incorrect');
                element.classList.remove("form__group-correct");
                icon.classList.add('fa-times-circle');
                icon.classList.add('form__group-incorrect');
                icon.classList.remove('fa-check-circle');
                text.classList.add('form__input-error-active');
                require.classList.remove('form__input-void-active');
            }else{
                element.classList.remove('form__group-incorrect');
                element.classList.add("form__group-correct");
                icon.classList.add('fa-check-circle');
                icon.classList.add('form__group-correct');
                icon.classList.remove('fa-times-circle');
                icon.classList.remove('form__group-incorrect');
                text.classList.remove('form__input-error-active');
                require.classList.remove('form__input-void-active');
            }
        }else{
            element.classList.add('form__group-incorrect');
            element.classList.remove("form__group-correct");
            icon.classList.remove('fa-check-circle');           
            require.classList.add('form__input-void-active');
            text.classList.remove('form__input-error-active');
        }
    }

    ValidateLicTradNum = async () => {
        const { businessPartner} = this.props;
        let element= document.getElementById('rfc');
        let icon=  document.querySelector(`#grupo__rfc i`);
        let text= document.querySelector(`#grupo__rfc .form__input-error`);
        let require= document.querySelector(`#grupo__rfc .form__input-void`);
        if (!businessPartner.LicTradNum == ''){
            if (!RFC_FORMAT.test(businessPartner.LicTradNum)){
                element.classList.add('form__group-incorrect');
                element.classList.remove("form__group-correct");
                icon.classList.add('fa-times-circle');
                icon.classList.add('form__group-incorrect');
                icon.classList.remove('fa-check-circle');
                text.classList.add('form__input-error-active');
                require.classList.remove('form__input-void-active');
            }else{
                element.classList.remove('form__group-incorrect');
                element.classList.add("form__group-correct");
                icon.classList.add('fa-check-circle');
                icon.classList.add('form__group-correct');
                icon.classList.remove('fa-times-circle');
                icon.classList.remove('form__group-incorrect');
                text.classList.remove('form__input-error-active');
                require.classList.remove('form__input-void-active');
            }
        }else{
            element.classList.add('form__group-incorrect');
            element.classList.remove("form__group-correct");
            icon.classList.remove('fa-check-circle');           
            require.classList.add('form__input-void-active');
            text.classList.remove('form__input-error-active');
        }
    }

    ValidatePhone = async () => {
        const { businessPartner} = this.props;
        let element= document.getElementById('phone');
        let icon=  document.querySelector(`#grupo__phone i`);
        let text= document.querySelector(`#grupo__phone .form__input-error`);
        let require= document.querySelector(`#grupo__phone .form__input-void`);
        if (!businessPartner.Phone == ''){ 
            if (!PHONE_FORMAT.test(businessPartner.Phone)){
                element.classList.add('form__group-incorrect');
                element.classList.remove("form__group-correct");
                icon.classList.add('fa-times-circle');
                icon.classList.add('form__group-incorrect');
                icon.classList.remove('fa-check-circle');
                text.classList.add('form__input-error-active');
                require.classList.remove('form__input-void-active');
            }else{
                element.classList.remove('form__group-incorrect');
                element.classList.add("form__group-correct");
                icon.classList.add('fa-check-circle');
                icon.classList.add('form__group-correct');
                icon.classList.remove('fa-times-circle');
                icon.classList.remove('form__group-incorrect');
                text.classList.remove('form__input-error-active');
                require.classList.remove('form__input-void-active');
            }
        }else{
            element.classList.remove("form__group-incorrect");
            icon.classList.remove('fa-check-circle'); 
            icon.classList.remove('fa-times-circle');
            text.classList.remove('form__input-error-active');
        }
    }

    ValidateE_mail = async () => {
        const { businessPartner} = this.props;
        let element= document.getElementById('email');
        let icon=  document.querySelector(`#grupo__email i`);
        let text= document.querySelector(`#grupo__email .form__input-error`);
        let require= document.querySelector(`#grupo__email .form__input-void`);
        if (!businessPartner.E_mail == ''){ 
            if (!EMAIL_FORMAT.test(businessPartner.E_mail)){
                element.classList.add('form__group-incorrect');
                element.classList.remove("form__group-correct");
                icon.classList.add('fa-times-circle');
                icon.classList.add('form__group-incorrect');
                icon.classList.remove('fa-check-circle');
                text.classList.add('form__input-error-active');
                require.classList.remove('form__input-void-active');
            }else{
                element.classList.remove('form__group-incorrect');
                element.classList.add("form__group-correct");
                icon.classList.add('fa-check-circle');
                icon.classList.add('form__group-correct');
                icon.classList.remove('fa-times-circle');
                icon.classList.remove('form__group-incorrect');
                text.classList.remove('form__input-error-active');
                require.classList.remove('form__input-void-active');
            }
        }else{
            element.classList.remove("form__group-incorrect");
            icon.classList.remove('fa-check-circle'); 
            icon.classList.remove('fa-times-circle');
            text.classList.remove('form__input-error-active');
        }   
    }

    ValidateGroup = async () => {
        const { businessPartner} = this.props;
        let element= document.getElementById('groupClient');
        let require= document.querySelector(`#grupo__groupClient .form__input-void`);
        if (!businessPartner.GroupCode == ''){
            element.classList.remove('form__group-incorrect');
            element.classList.add("form__group-correct");
            require.classList.remove('form__input-void-active');
        }else{
            element.classList.add('form__group-incorrect');
            element.classList.remove("form__group-correct");           
            require.classList.add('form__input-void-active');
        }   
    }

    ValidatePriceList = async () => {
        const { businessPartner} = this.props;
        let element= document.getElementById('priceList');
        let require= document.querySelector(`#grupo__priceList .form__input-void`);
        if (!businessPartner.PriceListNum == ''){
            element.classList.remove('form__group-incorrect');
            element.classList.add("form__group-correct");
            require.classList.remove('form__input-void-active');
        }else{
            element.classList.add('form__group-incorrect');
            element.classList.remove("form__group-correct");           
            require.classList.add('form__input-void-active');
        }   
    }

    ValidateAll = async()=>{
        this.ValidateFirstName();
        this.ValidateLastName();
        this.ValidateE_mail();
        this.ValidateLicTradNum();
        this.ValidateCardCode();
        this.ValidatePhone();
        this.ValidateGroup();
        this.ValidatePriceList();
    }

    ValidateBusinessPartner = async () => {
        const { businessPartner} = this.props;
        this.ValidateAll();
        if (!businessPartner.CardName || 
            !businessPartner.CardCode ||
            !businessPartner.LicTradNum ||
            !businessPartner.GroupCode ||
            !businessPartner.PriceListNum
            ) {
            return;
        }
        $('#newClientModal').modal('hide');
        $('#vmNewClient').modal('show');
    }
    ResetValidations = async () => {
        const ids=[ 
            'firstName',
            'lastName', 
            'cardCode',
            'rfc',
            'phone',
            'groupClient',
            'priceList',
            'email'
        ];
        for (let index = 0; index < ids.length; index++) {
            let element= document.getElementById(ids[index]);
            let icon=  document.querySelector(`#grupo__`+ids[index]+` i`);
            let text= document.querySelector(`#grupo__`+ids[index]+` .form__input-error`);
            let require= document.querySelector(`#grupo__`+ids[index]+` .form__input-void`);
            element.classList.remove("form__group-correct");
            element.classList.remove('form__group-incorrect');
            if (ids[index]!= 'groupClient' && ids[index]!= 'priceList') {
                icon.classList.remove('fa-check-circle'); 
                icon.classList.remove('fa-times-circle');
                text.classList.remove('form__input-error-active');
            }
            require.classList.remove('form__input-void-active');
        } 
    }
    
    ResetModal = async ()=>{
        const {clearData} = this.props;
        await this.ResetValidations();
        await clearData();
    }

    render() {
        const {
            businessPartner,
            groupNumList,
            CreateBusinessPartner,
            priceList,
            groupCodeList,
        } = this.props;

        return (
            <div>
                <div className="modal fade" id="newClientModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="newClientModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className="container" >
                                    <h4>Nuevo cliente</h4>
                                    <form>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-group" id="grupo__firstName">
                                                    <label htmlFor="firstName">Nombre</label>
                                                    <div className="form__group-input">
                                                        <input
                                                            type="text"
                                                            className="form-control form__input"
                                                            placeholder="Nombre"
                                                            id="firstName"
                                                            name="firstName"
                                                            value={businessPartner.CardName || ''}
                                                            onChange={(event) => this.ChangeCardName(event.target.value)} 
                                                            onBlur={this.ValidateFirstName}/>
                                                        <i className="form__validation-state fa fa-times-circle"></i>
                                                    </div>
                                                    <p className="form__input-error">Solo letras, min 3 y max 15.</p>
                                                    <p className="form__input-void">Nombre no puede ir vacio.</p>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-group formulario__grupo" id="grupo__lastName">
                                                    <label htmlFor="lastName">Apellidos</label>
                                                    <div className="form__group-input">
                                                        <input
                                                            type="text"
                                                            className="form-control form__input"
                                                            placeholder="Apellidos"
                                                            id="lastName"
                                                            name="lastName"
                                                            value={businessPartner.CardLastName || ''}
                                                            onChange={(event) => this.ChangeCardLastName(event.target.value)} 
                                                            onBlur={this.ValidateLastName}/>
                                                        <i className="form__validation-state fa fa-times-circle"></i>
                                                    </div>
                                                    <p className="form__input-error">Solo letras, min 3 y max 35.</p>
                                                    <p className="form__input-void">Apellido no puede ir vacio.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-group formulario__grupo" id="grupo__cardCode">
                                                    <label htmlFor="cardCode">Código</label>
                                                    <div className="form__group-input">
                                                        <input
                                                            type="text"
                                                            className="form-control form__input"
                                                            placeholder="Código"
                                                            id="cardCode"
                                                            value={businessPartner.CardCode || ''}
                                                            onChange={(event) => this.ChangeCardCode(event.target.value)} 
                                                            onBlur={this.ValidateCardCode}/>
                                                        <i className="form__validation-state fa fa-times-circle"></i>
                                                    </div>
                                                    <p className="form__input-error">Solo letras, números o guiones, min 3 y max 16.</p>
                                                    <p className="form__input-void">Código no puede ir vacio.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-group formulario__grupo" id="grupo__rfc">
                                                    <label htmlFor="rfc">RUT</label>
                                                    <div className="form__group-input">
                                                        <input
                                                            type="text"
                                                            className="form-control form__input"
                                                            placeholder="RUT"
                                                            id="rfc"
                                                            value={businessPartner.LicTradNum || ''}
                                                            onChange={(event) => this.ChangeLicTradNum(event.target.value)} 
                                                            onBlur={this.ValidateLicTradNum}/>
                                                        <i className="form__validation-state fa fa-times-circle"></i>
                                                    </div>                                                    
                                                </div>
                                            </div>
                                            <div className="col-12 form-group formulario__grupo" id="grupo__rfc">
                                                <p className="form__input-error" style={{marginTop: "-14px"}}>{"Formatos validos: (XAXX010101000), (XAXX-010101-000) o (XAXX 010101 000)"}</p>
                                                <p className="form__input-void" style={{marginTop: "-14px"}}>RUT no puede ir vacio.</p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-group formulario__grupo" id="grupo__phone">
                                                    <label htmlFor="phone">Teléfono</label>
                                                    <div className="form__group-input">
                                                        <input
                                                            type="text"
                                                            className="form-control form__input"
                                                            placeholder="Número de teléfono"
                                                            id="phone"
                                                            value={businessPartner.Phone || ''}
                                                            onChange={(event) => this.ChangePhone(event.target.value)} 
                                                            onBlur={this.ValidatePhone}/>
                                                        <i className="form__validation-state fa fa-times-circle"></i>
                                                    </div>
                                                    <p className="form__input-error">Solo números y deben ser 10 digitos.</p>
                                                    <p className="form__input-void">Teléfono no puede ir vacio.</p>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-group">
                                                    <label htmlFor="first-name">Condiciones de pago</label>
                                                    <select
                                                        id="creditDays"
                                                        className="form-control"
                                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                                        value={businessPartner.GroupNum || '---'}
                                                        onChange={(event) => this.ChangeGroupNum(event.target.value)}>
                                                        {!!groupNumList &&
                                                            groupNumList.map((group) => {
                                                                return (
                                                                    <option key={`PSPaygroup${group.GroupNum}`} value={group.GroupNum}>{group.PymntGroup || ''}</option>
                                                                )
                                                            })}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-6" id="grupo__groupClient">
                                                <div className="form-group form__group-input">
                                                    <label htmlFor="first-name">Grupo</label>
                                                    <select
                                                        id="groupClient"
                                                        className="form-control form__input"                                                        
                                                        value={businessPartner.GroupCode}
                                                        onChange={(event) => this.ChangeGroupCode(event.target.value)}
                                                        onBlur={this.ValidateGroup}>
                                                        <option value="" disabled hidden>Selecciona aquí</option>
                                                        {!!groupCodeList &&
                                                            groupCodeList.map((group) => {
                                                                return (
                                                                    <option key={`PSGroupNum${group.GroupCode}`} value={group.GroupCode}>{group.GroupName || ''}</option>
                                                                )
                                                            })}
                                                    </select>
                                                    <p className="form__input-void">Elija un grupo.</p>
                                                </div>
                                            </div>
                                            <div className="col-6" id="grupo__priceList">
                                                <div className="form-group form__group-input">
                                                    <label htmlFor="priceList">Lista de precios</label>
                                                    <select
                                                        id="priceList"
                                                        className="form-control form__input"
                                                        value={businessPartner.PriceListNum}
                                                        onChange={(event) => this.ChangePriceListNum(event.target.value)}
                                                        onBlur={this.ValidatePriceList}>
                                                        <option value="" disabled hidden>Selecciona aquí</option>
                                                        {!!priceList &&
                                                            priceList.map((list) => {
                                                                return (
                                                                    <option key={`PSListNum${list.ListNum}`} value={list.ListNum}>{list.ListName || ''}</option>
                                                                )
                                                            })}
                                                    </select>
                                                    <p className="form__input-void">Elija una lista.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group formulario__grupo" id="grupo__email">
                                            <label htmlFor="email">Email</label>
                                            <div className="form__group-input">
                                                <input
                                                    type="text"
                                                    className="form-control form__input"
                                                    placeholder="Dirección de correo electronico"
                                                    id="email"
                                                    value={businessPartner.E_mail || ''}
                                                    onChange={(event) => this.ChangeE_mail(event.target.value)}
                                                    onBlur={this.ValidateE_mail} 
                                                    />
                                                <i className="form__validation-state fa fa-times-circle"></i>
                                            </div>
                                            <p className="form__input-error">Ingrese una dirección de correo electronico valido.</p>
                                            <p className="form__input-void">El correo no puede ir vacio.</p>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <div className="col-sm-12">
                                    <div className="m-2 row">
                                        <button type="button" className="btn-lg btn-secondary col-3 ml-2 mr-4" data-dismiss="modal" data-target="#vmCancelNewClient" data-toggle="modal">Cancelar</button>
                                        <button className="btn-lg btn-primary d-block w-100 col-8" type="submit" onClick={this.ValidateBusinessPartner} >Guardar</button></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <ValidationModal
                    idValidation="vmNewClient"
                    message="¿Esta seguro que quiere continuar?"
                    idModalOrigin="#newClientModal"
                    eventOnclick={CreateBusinessPartner} />

                <ValidationModal
                    idValidation="vmCancelNewClient"
                    message="¿Esta seguro que quiere cancelar?"
                    idModalOrigin="#newClientModal"
                    idModalDestiny="#clientsModal"
                    eventOnclick={this.ResetModal} />
            </div>
        );
    }
}

export default NewClientModal;